import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import { FiChevronLeft } from 'react-icons/fi'
import { useLocation, useNavigate } from 'react-router-dom'

import UserStore from '../stores/UserStore'
import LoadingIndicator from '../components/atoms/loadingIndicator'
import BottomBarComponent from '../components/templates/BottomBarComponent'

const UseAppScreen = observer(() => {
  const navigate = useNavigate()
  const location = useLocation()
  const pathMapper = {
    '/novel': '웹소설',
    '/mypage': '보관함',
    '/mission': '내 코인',
  }
  const pageName = pathMapper[location.pathname]

  useEffect(() => {
    UserStore.setIsLoaded(true)
  }, [])

  const HeaderComponent = () => {
    return (
      <section className="z-10 py-2 flex flex-row items-center justify-between overflow-hidden">
        <button
          aria-label="goBack"
          type="button"
          className="mx-2 p-2 whitespace-nowrap"
          onClick={async () => {
            navigate(-1)
          }}
        >
          <FiChevronLeft className="w-8 h-8 stroke-[0.2vw]" />
        </button>
        <div className="flex font-bold">{pageName}</div>
        <div className="w-16" />
      </section>
    )
  }

  const AppLogoComponent = () => {
    return (
      <div className="flexCol justify-center items-center w-[100vw] h-[80vh] border">
        <img src="/images/toon/AppLogo.png" alt="" className="w-[24vw] h-[24vw]" />

        <div className="h-[4vw]" />

        <div className="text-center text-[6vw] font-bold">
          {pageName}은 올웨이즈 앱에서만 <br /> 사용할 수 있어요
        </div>

        <div className="h-[10vw]" />

        <button className="w-[70vw] py-[4vw] bg-[#F8323E] text-white text-[5vw] font-bold rounded-full">
          앱에서 이용하기
        </button>
      </div>
    )
  }

  if (!UserStore.isLoaded) {
    return <LoadingIndicator isLoading />
  }
  return (
    <div>
      <HeaderComponent />
      <AppLogoComponent />
      <BottomBarComponent />
    </div>
  )
})

export default UseAppScreen
